import { NUMBER } from '@constants/common/number';
import { useState, useEffect, useRef, useCallback } from 'react';

const useTimer = (initialMinutes: number) => {
    initialMinutes = initialMinutes > 0 ? initialMinutes : NUMBER.ZERO;
    const [time, setTime] = useState(initialMinutes * 60);
    const [isRunning, setIsRunning] = useState(false);
    const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

    const tick = useCallback(() => {
        setTime(prevTime => {
            if (prevTime <= 1) {
                stop();
                return 0;
            }
            return prevTime - 1;
        });
    }, []);

    const start = useCallback(() => {
        if (!isRunning && intervalRef.current === null) {
            setIsRunning(true);
            intervalRef.current = setInterval(tick, 1000);
        }
    }, [isRunning, tick]);

    const stop = useCallback(() => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            setIsRunning(false);
        }
    }, []);

    const reset = useCallback(() => {
        stop();
        setTime(initialMinutes * 60);
    }, [initialMinutes, stop]);

    useEffect(() => {
        return () => stop();
    }, [stop]);

    useEffect(() => {
        setTime(initialMinutes * 60);
    }, [initialMinutes]);

    return {
        rawTime: time,
        start,
        stop,
        reset,
        isRunning,
    };
};

export default useTimer;
